import styled from 'styled-components'

const SearchContainer = styled.div`
  background: ${(props) => props.theme.panelBgLight};
  flex: 0 0 auto;
`

export default SearchContainer
